<template>
    <div class="m">
        <div class="category" v-for="(cat, cindex) in cats" v-bind:key="cindex" id="ckey">
            <div class="cat-header">
                <span class="title">{{cat.attrs.cname}}</span>
            </div>
            <div class="cat-items" v-for="i in cat.rc" v-bind:key="i">
                <div v-for="(site, sindex) in cat.sites.slice((i - 1) * itemNum, i * itemNum)" v-bind:key="sindex" @click="showItemModal(cindex, (i - 1) * itemNum + sindex)">
                    <akmitem :site="site" :cwidth="itemWidth" v-if="site.site !== 'aknull'"></akmitem>
                    <akmnull :cwidth="itemWidth" v-else></akmnull>
                </div>
            </div>
        </div>
        <!-- <div id="ad_mid" style="margin-top:10px; text-align: center;">
          <Adsense
              data-ad-client="ca-pub-4700907130335184"
              data-ad-slot="8705653315">
          </Adsense>
        </div> -->
        <div class="item-modal-box" v-if="showItem === true" :style="{height: windowHeight + 'px'}">
            <akmitemModal :site="actSite" :mheight="modalHeight"></akmitemModal>
            <div class="close-box">
                <img class="close-img" src="../assets/images/close.png"  @click="hideUpModal">
            </div>
        </div>
        <loading v-if="showLoading" :lhint="loadingHint"></loading>
        <div class="item-modal-box" v-if="showFeedBack === true" :style="{height: windowHeight + 'px'}">
            <feedback></feedback>
            <div class="close-box">
                <img class="close-img" src="../assets/images/close.png"  @click="hideUpModal">
            </div>
        </div>
        <div class="item-modal-box" v-if="showSupport === true" :style="{height: windowHeight + 'px'}">
            <support></support>
            <div class="close-box">
                <img class="close-img" src="../assets/images/close.png"  @click="hideUpModal">
            </div>
        </div>
        <!-- <div class="more-ops">
            <div class="s-item support" @click="toggleSupport">
            </div>
            <div class="s-item feedback" @click="toggleFeedback">
            </div>
            <div class="s-item about" @click="toggleAbout">
            </div>
        </div> -->
    </div>
</template>

<script>
import Vue from 'vue'
import akmitem from '../components/AKMItem.vue'
import akmitemModal from '../components/AKMItemModal.vue'
import akmnull from '../components/AKMNull'
import loading from '../components/Loading'
import feedback from '../components/FeedBack'
import support from '../components/Support'
/* eslint-disable */
export default {
    name: "m",
    data() {
      return{
        itemNum: 3,
        cats: [],
        itemWidth: 100,
        showItem: false,
        actSite: {},
        modalHeight: 450,
        showLoading: false,
        loadingHint: 'Loading',
        windowHeight: 0,
        showFeedBack: false,
        showSupport: false,
        akMobAd: false
      }
    },
    components: {
      support,
      akmnull,
      akmitem,
      akmitemModal,
      loading,
      feedback
    },
    created: function () {
      //动态设置index.html中内容
      //document.title = 'New Title'
      document.head.querySelector('meta[name=viewport]').content = 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'

      var _width = screen.width
      if(_width <= 380){
        this.itemWidth = 100
      }
      else{
        this.itemWidth = 120
      }
      //每次显示前调用高度，避免创建之后高度发生变化...ios会自动隐藏底部bar
      //计算modal可用的剩余高度, 减去底部关闭按钮所占的高度
      //浏览器上下菜单占用高度，不应该用screen的高度
      var _height = window.innerHeight
      this.modalHeight = _height - 85
      this.windowHeight = _height
      window.addEventListener('resize', this.updateWindowHeight);
      var that = this
      this.$http.get('/boot', {}, function (r) {
        if (r.status === 0) {
          var _cats = r.data.cats
          for(var i =0; i < _cats.length; i++){
            _cats[i]['rc'] = Math.ceil(_cats[i]['sites'].length / that.itemNum)
            //控制item是显示完整还是单独的一个图标
            // _cats[i]['mode'] = 'collapse'
            //计算需要填充的空item数目
            var _nullNum = 0
            if(_cats[i]['sites'].length % that.itemNum !== 0){
              _nullNum = that.itemNum - _cats[i]['sites'].length % that.itemNum
            }
            var j = 0
            while(j < _nullNum){
              _cats[i]['sites'].push({'site': 'aknull'})
              j++
            }
          }
          that.cats = _cats
          // console.log('hello, ak')
          if('mods' in r.data){
            that.akMobAd = r.data.mods.ak_mob_ad
          }
        }
      })
      localStorage.setItem('from', 'm')
    },
  destroyed() {
    window.removeEventListener('resize',this.updateWindowHeight);
  },
    methods: {
      showItemModal: function (cindex, sindex){
        var _site = this.cats[cindex].sites[sindex]
        var that = this
        if(_site.site !== 'aknull'){
          this.showLoading = true
          this.$http.get('/sites/' + _site.site, {}, function (r) {
            if (r.status === 0) {
              that.showLoading = false
              var _site = r.data.site
              // 判断网站，如果网站为好奇心日报，截断标题，最长显示55个字
              if(_site.site === 'qdaily'){
                for (var sname in _site.subs){
                  var _sub = _site.subs[sname]
                  for (var i = 0; i < _sub.items.length ; i++){
                    if(_sub.items[i].title.length > 50){
                      _sub.items[i].title = _sub.items[i].title.substr(0, 47) + '...'
                    }
                  }
                }
              }
              that.actSite = _site
              that.showItem = true
              that.toggleBodyClass('addClass', 'modal-open')
            }
          })
        }
      },
      updateWindowHeight: function() {
        // alert(window.innerHeight)
        this.windowHeight = window.innerHeight
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;
        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
      toggleFeedback: function (){
        this.showFeedBack = !this.showFeedBack
      },
      toggleSupport: function (){
          this.showSupport = !this.showSupport
      },
      toggleAbout: function () {
        window.location.href =  'https://www.anyknew.com/board/notifications'
      },
      hideUpModal: function () {
        this.showItem = false
        this.showFeedBack = false
        this.showSupport = false
        this.toggleBodyClass('delClass', 'modal-open')
      },
      toggleCatMode: function (index) {
        if(this.cats[index].mode === 'mini'){
          // 判断当前分类是否已经加载了数据，若没有加载数据，加载该分类下数据
          if(this.cats[index].inited === false){
            var that = this
            this.$http.get('/cats/' + this.cats[index]['cat'], {}, function (r) {
              if (r.status === 0) {
                // that.cats[index] = r.data.cat
                var _cat = r.data.cat
                _cat['rc'] = Math.ceil(_cat['sites'].length / that.itemNum)
                //控制item是显示完整还是单独的一个图标
                // _cats[i]['mode'] = 'collapse'
                //计算需要填充的空item数目
                var _nullNum = 0
                if(_cat['sites'].length % that.itemNum !== 0){
                  _nullNum = that.itemNum - _cat['sites'].length % that.itemNum
                }
                var j = 0
                while(j < _nullNum){
                  _cat['sites'].push({'site': 'aknull'})
                  j++
                }
                _cat.mode = 'collapse'
                // that.cats[index] = _cat
                Vue.set(that.cats, index, _cat)
              }
            })
          }
          else{
            //直接设置展开
            Vue.set(this.cats[index], 'mode', 'collapse')
          }
        }
        else{
          // this.cats[index].mode = 'mini'
          Vue.set(this.cats[index], 'mode', 'mini')
        }
      }
    }
  }
</script>

<style lang="less">
    .m{
        /*width: 100%;*/
        margin: auto;
        position: relative;
        .item-modal-box{
            position: fixed;
            z-index: 4700;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .7);
            display: table;
            transition: opacity .3s ease;
            .close-box{
                padding: 15px 0;
                text-align: center;
                .close-img{
                    width: 25px;
                }
            }
        }
        .more-ops{
            /*width: 100%;*/
            height: 60px;
            /*padding: 0 10px;*/
            background-color: #FFFFFF;
            margin: 20px 10px 10px 10px;
            padding: 10px 0;
            display: flex;
            justify-content: center;
            border-radius: 5px;
            .s-item{
                width: 40px;
                margin: 0 10px;
                height: 40px;
                /*border-radius: 5px;*/
                background-color: #FFFFFF;
                cursor: pointer;
                &.about{
                    background-image: url("../assets/images/akicon.png");
                    background-size: 30px 30px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background-color: #3DB4F1;
                        background-image: url("../assets/images/akicon-i.png");
                    }
                }
                &.feedback{
                    background-image: url("../assets/images/feedback.png");
                    background-size: 25px 25px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background-color: #3DB4F1;
                        background-image: url("../assets/images/feedback-i.png");
                    }
                }
                &.support{
                    background-image: url("../assets/images/support-c.png");
                    background-size: 25px 25px;
                    background-position: center;
                    background-repeat: no-repeat;
                    &:hover{
                        background-color: #3DB4F1;
                        background-image: url("../assets/images/support-i.png");
                    }
                }
            }
        }
        .category{
            width: 100%;
            .cat-header{
                text-align: left;
                padding: 0 10px;
                padding-top: 20px;
                .title{
                    flex: 1;
                    font-size: 1.2rem;
                }
            }
            .cat-items{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding: 0 10px;
                padding-top: 20px;
            }
        }
    }

</style>